import { withObjectionFaqs } from "@/lib/faqs";
import { createFileRoute } from "@tanstack/react-router";
import { ServicePageLayout } from "@/components/ServicePageLayout";
import { SERVICE_PAGES } from "@/lib/service-content";
import { buildService, buildFaqPage, buildBreadcrumbs, buildLocalBusiness } from "@/components/SchemaJsonLd";

const data = SERVICE_PAGES["flake-epoxy-flooring"];

export const Route = createFileRoute("/services/flake-epoxy-flooring")({
  head: () => ({
    meta: [
      { title: "Flake Epoxy Flooring in the Calgary region | MLC Epoxy Floors" },
      { name: "description", content: "Premium flake epoxy garage floor coatings serving Calgary, Calgary and surrounding areas. Diamond-ground prep, polyaspartic topcoat, 1-day install." },
      { property: "og:title", content: "Flake Epoxy Flooring | MLC Epoxy Floors" },
      { property: "og:description", content: "Premium full-broadcast flake epoxy floors with UV-stable polyaspartic topcoat — installed in a single day." },
      { property: "og:url", content: "/services/flake-epoxy-flooring" },
    ],
    links: [{ rel: "canonical", href: "/services/flake-epoxy-flooring" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildLocalBusiness()) },
      { type: "application/ld+json", children: JSON.stringify(buildService(data.name, data.slug, data.intro)) },
      { type: "application/ld+json", children: JSON.stringify(buildFaqPage(withObjectionFaqs(data.faqs))) },
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" }, { name: "Services", href: "/services" }, { name: data.name, href: `/services/${data.slug}` }
      ])) },
    ],
  }),
  component: () => <ServicePageLayout {...data} />,
});
